<template>
  <van-config-provider :theme-vars="themeVars" style="height: 100%">
    <!--<van-nav-bar safe-area-inset-top />-->
    <div style="display: flex; flex-direction: column; height: 100%">
      <van-nav-bar class="nav-header" :title="$store.getters.title" :left-text="showBack ? '返回' : ''" :left-arrow="showBack" @click-left="onLeftClick" fixed :z-index="1000">
        <template #left v-if="$route.meta.home && user">
          <van-icon name="wap-nav" :size="24" />
        </template>
        <template #right>
          <van-icon v-if="$route.meta.search" name="search" size="18" @click="search" />
          <van-icon v-if="$route.meta.toDoc" name="orders-o" size="18" @click="toHktDoc" />
          <van-icon v-if="$route.meta.print" name="printer" size="18" @click="onPrinter" />
        </template>
      </van-nav-bar>

      <van-popup v-if="user" position="left" v-model:show="showDrawer">
        <div class="drawer" v-if="user">
          <div class="drawer-header">
            <img style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%" src="@/assets/images/header.jpg" />
            <div class="avatar">
              <img v-if="user.avatar && user.avatar.length > 0" :src="$res.remote(user.avatar)" />
              <img v-else src="@/assets/images/avatar.png" />
            </div>
            <div style="margin: 10px 0; font-weight: bold; z-index: 100">
              {{ user.fullName }}
            </div>
            <div style="font-size: 13px; z-index: 100">
              {{ user.emp.department?.$label }}
            </div>
          </div>
          <van-cell-group title="组织">
            <template v-for="org in format(allOrgs,false,null)" :key="org.id">
                <van-cell v-if="isCurrOrg(org)" icon="location-o" :title-style="{ color: 'red' }" :title="org.name"></van-cell>
                <van-cell v-else :isLink="true" :title="org.name" @click="changeOrg(org)"></van-cell>
            </template>
            <van-collapse accordion v-model="activeName" class="entrycls">
              <van-collapse-item v-for="org in orgGroups()" :title="org" :name="org">
                <template v-for="o in format(allOrgs,true,org)">
                  <van-cell v-if="isCurrOrg(o)" icon="location-o" :title-style="{ color: 'red' }" :title="o.name"></van-cell>
                  <van-cell v-else :isLink="true" :title="o.name"  @click="changeOrg(o)"/>
                </template>
              </van-collapse-item>
            </van-collapse>
          </van-cell-group>
          <van-cell-group title=" ">
            <van-cell icon="user-o" :isLink="true" title="退出登录" @click="logout"></van-cell>
          </van-cell-group>
        </div>
      </van-popup>
      <div class="containerBox" ref="print">
        <template v-if="$route.path != '/login'">
          <router-view v-slot="{ Component, route }" :key="user ? user?.currOrg?.id : 0">
            <keep-alive :max="10" :exclude="noKeepAlivePages">
              <component :is="Component" :key="route.fullPath" v-if="!route.meta.noKeepAlive" />
              <component :is="Component"  v-else />
            </keep-alive>
          </router-view>
        </template>
        <router-view v-else />
      </div>
      <div v-if="!$editDialog.isEmpty()">
        <DialogReader v-for="(dialog, index) in $editDialog.getItems()" :key="index" :dialog="dialog"></DialogReader>
      </div>
      <!-- <van-back-top :duration="300" /> -->
    </div>
  </van-config-provider>
  <van-number-keyboard safe-area-inset-bottom />
</template>

<script>
import routeConfig from "./router/routeConfig.js";
import { Dialog } from "vant";
import { ref } from "vue";
export default {
  data() {
    return {
      showDrawer: false,
      dark: false,
      themeVars: {
        primaryColor: "#335883",
        navBarBackgroundColor: "#335883",
        navBarTextColor: "#ffffff",
        navBarTitleTextColor: "#ffffff",
        navBarIconColor: "#ffffff",
        rateIconFullColor: "#335883",
        //field-disabled-text-color
        // --van-field-input-disabled-text-color
        // sliderBarHeight: '4px',
        // sliderButtonWidth: '20px',
        // sliderButtonHeight: '20px',
        sliderActiveBackgroundColor: "#335883",
        buttonPrimaryBorderColor: "#335883",
        buttonPrimaryBackgroundColor: "#335883",
      },
      activeName:"",
    };
  },
  created() {
    // setInterval(() => {
    //   // console.log("@@@@@2",this.$store.state.user)
    //   if (this.$store.state.user && this.$store.state.user.menuData.Check && this.$store.state.user.menuData.Check.length > 0) {
    //     // console.log("@@@@@")
    //     this.$store.dispatch("getUnReadCount");
    //   }
    // }, 5*60 * 1000);
  },
  computed: {
    showBack() {
      let urls = ["/", "/home", "/report", "/user", "/login"];
      return urls.indexOf(this.$route.path) == -1 && !!this.user;
    },
    user() {
      return this.$store.getters.user;
    },
    allOrgs() {
      return this.$store.getters.user.allOrgs;
    },
    noKeepAlivePages() {
      return routeConfig.getNoKeepAlivePages();
    },
    isWechat() {
      return this.$util.isWechat();
    },
    isAutoLogin() {
      if (this.user) {
        return this.user.emp?.autoLogin;
      }
    },
  },
  methods: {
    format(allOrgs,isGroup,group){
      let items=[]
      let items2=[]
      const $self=this;
      this.allOrgs.forEach(item => {
        if(item.orgGroup){
          items.push(item);
        }else{
          items2.push(item);
        }
      });
      if(isGroup){
        return items.filter(item=>item.orgGroup==group);
      }else{
        return items2;
      }
    },
    orgGroups( ){
      const all=this.$store.getters.user.allOrgs;
      return all.reduce((acc, o) => {
        const value = o.orgGroup;
        if(value){
          return acc.includes(value) ? acc : [...acc, value];
        }else{
          return acc;
        }
      }, []);
    },
    onPrinter() {
      window.print();
    },
    toHktDoc() {
      let url = "https://hkt.austars.net/hkt-doc/guide/";
      window.location.href = url;
    },
    onLeftClick() {
      if (this.$route.meta.home) {
        this.showDrawer = true;
      }
      // else if (this.$route.meta.broad) {
      //   this.$router.replace("/homePage");
      // }
      else {
        if (window.history.state.back) {
          this.$router.go(-1);
        } else {
          this.$router.replace("/homePage");
        }
      }
    },
    isCurrOrg(org) {
      return org.id == this.$store.state.user.currOrg.id;
    },
    async changeOrg(org) {
      if (this.isCurrOrg(org)) return;
      // console.log("切换组织",org)
      await this.$axios.execute("Account", "changeOrganization", { organization: org.id });
      this.$store.dispatch("getCurrAccount");
      // this.$store.dispatch('getUnReadCount')
      this.$util.success("切换成功");
    },
    logout() {
      if (this.isWechat && this.isAutoLogin) {
        Dialog.confirm({
          title: "提醒",
          message: "需要关掉自动登录才允许退出登录",
          confirmButtonText: "前往关闭",
          confirmButtonColor: "#ee0a24",
        })
          .then(() => {
            this.showDrawer = false;
            this.$router.push("/setting");
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.showDrawer = false;
        setTimeout(() => {
          this.$store.commit("logout", true);
        }, 100);
      }
    },
    search() {
      this.$eventBus.emit("searchClick");
    },
  },
};
</script>
<style lang="scss">
@media print {
  html,
  body {
    height: inherit;
  }
  @page {
    size: portrait;
  }
}
html {
  height: 100%;
  // margin: 0;
  padding: 0;
  background: #f5f5f5;
  font-size: 14px;
  // min-width: 320px;
  // max-width: 640px;
  margin: 0 auto;
}
body,
#app {
  height: 100%;
  // margin: 0;
  padding: 0;
  background: #f5f5f5;
  font-size: 14px;
  // min-width: 320px;
  max-width: 640px;
  margin: 0 auto !important;
}
:root {
  --van-primary-color: #335883;
}

.van-calendar__bottom-info {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.van-hairline--bottom:after {
  border: none !important;
}
.van-collapse-item__wrapper .van-cell--clickable {
  background-color: #e9e9e9 !important;
}
.van-collapse-item__title {
  background-color: #ffffff !important;
}
.entrycls .van-collapse-item__title {
  font-size: 16px!important;
  font-weight: 700;
}
.van-collapse-item__content {
  padding: 0 !important;
}
.drawer {
  width: 70vw;
  height: 100vh;
}

.drawer-header {
  background-size: 100% 100%;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  margin-bottom: 10px;
  position: relative;
}

.avatar {
  z-index: 100;
}

.avatar img {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  box-shadow: 0 0px 15px #335883;
}

.containerBox {
  flex: 1;
  margin-top: var(--van-nav-bar-height);
}

div {
  box-sizing: border-box;
}

label {
  font-weight: 500 !important;
  margin-bottom: 0 !important;
  display: inline !important;
}

.van-back-top {
  z-index: 1000;
}

.van-snackbar__content {
  word-break: break-all;
}

.van-tabs {
  transition: none !important;
}

.van-cell__title {
  min-width: 60px;
}

.van-cell__value {
  flex: 0 1 auto !important;
}

.van-field {
  align-items: center;
  .van-cell__value {
    flex: 1 !important;
  }
}

// .nav-header {
//     position: fixed!important;
//     top: 0;
//     width: 100%;
//     z-index: 1000!important;
// }

.van-pull-refresh {
  height: 100%;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}

.flot-btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 10;
  button {
    margin: 6px;
    flex: 1;
  }
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}
.footer-btns {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 10;
  width: 100%;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 3px;
}

.amount {
  color: #e64340;
  font-size: 15px;
  font-weight: bold;
}

.amount::before {
  content: "￥";
}

.img-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
  img {
    margin: 0 10px 10px 0;
    box-shadow: 0 0 6px #ccc;
  }
}

#nprogress .bar {
  width: 100% !important;
  z-index: 99 !important;
  background-color: #3d8fee !important;
  margin-top: var(--van-nav-bar-height) !important;
}
</style>
